import { User } from "interfaces/user";

export function isProfileMissingInfo(user: User): Boolean {
  return !(
    user.firstName &&
    user.lastName &&
    user.language &&
    user.assets?.find((a: any) => a.assetType === "profile_image")
  );
}

export function isLocationMissingInfo(user: User) {
  return !!user.profile?.address ? !user.profile?.shipHome && !user.profile?.shippingAddress : true;
}
